// 📄 data/solutionChannelsMap.ts
// Qué canales pertenece a cada solución, para la pestaña por solución del
// ProjectStatsPanel (useSolutionStats.ts). Ambas listas se derivan de la
// única fuente real de cada una — no se vuelven a tipear los canales acá:
//
// - Commerce: de COMMERCE_CHANNELS (useAllChannelsProgress.ts, que a su vez
//   viene de COMMERCE_CHECKLISTS en commerceChecklistCatalog.ts).
// - SLP / Sourcing / Contracts: de CANALES_INTEGRACION (integrationChannels.ts).
// - Buying / CIG: sin canales de integración definidos todavía en el código
//   (no hay checklist real que leer) — quedan con lista vacía a propósito,
//   useSolutionStats.ts lo interpreta como "progreso no disponible" en vez
//   de inventar datos.
import { CANALES_INTEGRACION, SolucionConCanales } from '../pages/Proyectos/integrationChannels.ts';
import { COMMERCE_CHANNELS } from '../hooks/useAllChannelsProgress.ts';

export interface SolutionChannelDef {
  id: string;
  nombre: string;
}

const canalesDe = (solucion: SolucionConCanales): SolutionChannelDef[] =>
  CANALES_INTEGRACION.filter((c) => c.solucion === solucion).map((c) => ({ id: c.slug, nombre: c.label }));

export const SOLUTION_CHANNELS: Record<string, SolutionChannelDef[]> = {
  commerce: COMMERCE_CHANNELS.map((c) => ({ id: c.id, nombre: c.label })),
  slp: canalesDe('slp'),
  sourcing: canalesDe('sourcing'),
  contracts: canalesDe('contracts'),
  buying: [],
  cig: []
};
